// extracted by mini-css-extract-plugin
export default {"products":"Ov-z","card":"Pv-z","oosMessaging":"Qv-z"};